export const THEME_SECTION_EXTENSION_ID = import.meta.env.VITE_THEME_SECTION_EXTENSION_ID

export const SHOPIFY_GRAPHQL_API_ENDPOINT = 'shopify:admin/api/2025-01/graphql.json'